import "./AlMulqaOvenCleaning.module.css";
import Header from "@/reusable_sections/Header";
import MalqaOvenLanding from "./sections/MalqaOvenLanding";
import OvenCleaningAlMulqa from "./sections/OvenCleaningAlMulqa";
import Footer from "@/reusable_sections/Footer";
export default function AlMulqaOvenCleaningPage() {
  return <div>
      <Header />
      <MalqaOvenLanding />
      <OvenCleaningAlMulqa />
      <Footer />
    </div>;
}